import { BehaviorSubject } from 'rxjs';
import { MessageModalData } from '../types/message';

export const isMessageModalOpen = new BehaviorSubject<MessageModalData | null>(null);

export const openMessageModal = (data: MessageModalData) => {
  if (!isMessageModalOpen.getValue()) {
    isMessageModalOpen.next({ ...data });
  }
};

export const closeMessageModal = () => {
  isMessageModalOpen.next(null);
};
